<template>
  <div>
    <div class="logo"/>
    <div class="skinny-content">
      <p/><h2 v-text="t('register.email_exp1')"/>
      <p v-html="t('register.email_exp2')"/>
      <ul>
        <li v-text="t('register.email_exp3')"/>
        <li v-text="t('register.email_exp4')"/>
      </ul>

      <p/><h3 v-text="t('register.email_exp5')"/>
      <p v-text="t('register.email_exp6')"/>
      <p v-text="t('register.email_exp7')"/>
      <ul>
        <li v-text="t('register.email_exp8')"/>
        <li v-text="t('register.email_exp9')"/>
        <li v-text="t('register.email_exp10')"/>
      </ul>
      <p v-text="t('register.email_exp11')"/>
      <ul>
        <li v-text="t('register.email_exp12')"/>
        <li v-text="t('register.email_exp13')"/>
        <li v-text="t('register.email_exp14')"/>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style type="text/css">
.logo {
  position: absolute;
  top: 19px;
  right: 5px;
  height: 38px;
  width: 150px;
  display: block;
  background: url(/images/logo-no-text.png) no-repeat left top;
}

.skinny-content {
  width: 23em;
  border-left: 1px solid #ccc;
  padding-left: 25px;
  margin-top: 30px;
}
</style>
